import { journeyAction, } from './base';

import { JourneyActionNoOp as JourneyActionNoOpBase, } from 'atlas-shared';

export const JourneyActionNoOp = journeyAction({
  ...JourneyActionNoOpBase,
});
